import { useEffect, useRef } from 'react';
export default function useDialogFocus(open, onClose) {
 const ref = useRef(null); const close = useRef(onClose); close.current = onClose;
 useEffect(() => {
  if (!open) return;
  const previous = document.activeElement; const overflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  const selectors = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]';
  const available = () => Array.from(ref.current?.querySelectorAll(selectors) || []).filter(el => el.getClientRects().length);
  available()[0]?.focus();
  const key = e => { if(e.key === 'Escape'){e.preventDefault();close.current?.();} if(e.key === 'Tab'){const nodes=available();const first=nodes[0],last=nodes[nodes.length-1];if(!first){e.preventDefault();return;}if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}} };
  document.addEventListener('keydown',key);
  return () => {document.removeEventListener('keydown',key);document.body.style.overflow=overflow;previous?.focus?.();};
 }, [open]);
 return ref;
}
